// Tipo da assembleia e a regra de quorum de instalacao (art. 37, § 2o, da Lei 11.101/2005).
// O id espelha general_meetings.convocation_type.
const data = [
  {
    id: 1,
    name: "Primeira convocação",
    short: "1ª convocação",
    rule: "Instala-se com a presença de credores titulares de mais da metade dos créditos de cada classe, computados pelo valor.",
  },
  {
    id: 2,
    name: "Segunda convocação",
    short: "2ª convocação",
    rule: "Instala-se com qualquer número de credores presentes.",
  },
  {
    id: 3,
    name: "Prosseguimento",
    short: "Prosseguimento",
    rule: "Continuação de sessão já instalada: o quórum de instalação não é reavaliado e a presença da instalação fica preservada.",
  },
];

export default [...data];
